import React from "react";
import BaseButton from "./BaseButton";
import carImage from "../assets/pictures/driver.webp"

function DriverCommercial() {
    return (
        <div className="driver-commercial-container">
            <img src={carImage} alt="" />
            <div className="text-block">
                <div className="subheading">VAIRUOKITE SU ETRANSPORT</div>
                <h1 className="heading">DIRBKITE KADA IR KIEK NORITE</h1>
                <p className="description">
                    Laisvė yra vienas iš svarbiausių dalykų mūsų gyvenimuose.
                    Tai suprasdami, sukūrėme Etransport platformą, kuri leidžia būti patiems sau
                    vadovu ar turėti laisvą grafiką.
                </p>
                <div className="buttons">
                    <BaseButton
                        className={"baseButton--primary"}
                        text={"REGISTRUOTIS"}
                        handleOnClick={() => window.location.href = 'https://1424.lt/vairuotojo-registracija/'}
                    />
                    <a href="https://1424.lt/vairuotojo-darbas/" className="link-secondary">PLAČIAU APIE DARBO SĄLYGAS</a>
                </div>
            </div>
        </div>
    )
}

export default DriverCommercial;